import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Cards,
  Checkbox,
  ColumnDatas,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  Table,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import {
  DocInfo,
  DocumentListReq,
  DocumentListResp,
  favoriteReq,
  FolderInfoDTO,
} from "../../types/files";
import DocAside from "../DocAside";
import DocSettingButton from "../DocSettingButton";
import DocCard from "../DocCard";
import utilsDocs from "../../shared/utils/docs";
import RevisionTag from "../RevisionTag";
import utilsCommon from "../../shared/utils/common";
import DeleteTag from "../DeleteTag";
import EmptyFilterPage from "../EmptyPage/EmptyFilterPage";
import EmptyInitFilterPage from "../EmptyPage/EmptyInitFilterPage";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { nanoid } from "@reduxjs/toolkit";
import docApi from "../../redux/api/DocApi";
import ConfirmDeleteOrRestoreModal from "../More/ConfirmDeleteOrRestoreModal";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import {
  handleDocDownload,
  handleDocPreview,
  gotoEditMode,
  uploadToAIAssistant,
} from "../../shared/utils/api";
import useStartDownload from "../../shared/hooks/useStartDownload";
import { Trans } from "react-i18next";
import i18n from "../../locales/i18n";
import { t } from "i18next";

interface DocumentBottomProps {
  filter?: DocumentListReq | favoriteReq;
  docInfo?: DocumentListResp;
  changeFilterByKey?: (key: string, value: any) => void;
  height?: string | number;
  listTableHeight?: string | number;
  cardTableHeight?: string | number;
  isInitFilter?: boolean;
  classes?: string;
  requiredRecallSyncId?: string[];
  changeRequiredRecallSyncIds?: (syncIds: string[]) => void;
  tableUpperActionBox?: (value?: DocInfo[]) => React.ReactNode;
  handleInitFilter?: () => void;
  endReached: () => void;
  handleClickButton?: () => void;
  page?:
    | "favorite"
    | "sendFile"
    | "receivedFile"
    | "trash"
    | "workgroupFile"
    | "search"
    | "manageStorage"
    | "manageStorage_trash"
    | "manageStorage_myBox";
}
export const SORT_TYPE = [
  { label: t("common.sortDateNewFirst"), key: "datedesc" },
  { label: t("common.sortDateNewLast"), key: "date" },
  { label: t("common.sortDateNameAsc"), key: "name" },
  { label: t("common.sortDateNameDesc"), key: "namedesc" },
];
const VISIBLE_TAB_BY_PAGE = {
  search: ["star", "fileName", "memo", "info", "lastUpdate", "masterUser"],
  favorite: [
    "star",
    "fileName",
    "memo",
    "info",
    "workgroup",
    "lastUpdate",
    "masterUser",
  ],
  sendFile: [
    "checkbox",
    "star",
    "fileName",
    "memo",
    "info",
    "lastUpdate",
    "receiver",
  ],
  receivedFile: [
    "checkbox",
    "star",
    "fileName",
    "memo",
    "info",
    "lastUpdate",
    "sender",
  ],
  trash: ["checkbox", "fileName", "workgroup", "lastUpdate"],
  workgroupFile: [
    "checkbox",
    "star",
    "fileName",
    "memo",
    "info",
    "lastUpdate",
    "masterUser",
  ],
  manageStorage_trash: [
    "checkbox",
    "fileName",
    "workgroup",
    "fileSize",
    "masterUser",
    "lastUpdate",
  ],
  manageStorage_myBox: [
    "checkbox",
    "fileName",
    "workgroup",
    "fileSize",
    "masterUser",
    "lastUpdate",
  ],
  manageStorage: [
    "checkbox",
    "fileName",
    "workgroup",
    "fileSize",
    "masterUser",
    "lastUpdate",
  ],
};
const copy = require("clipboard-copy");

const DocumentBottom: React.FC<DocumentBottomProps> = ({
  filter,
  docInfo,
  changeFilterByKey,
  height,
  listTableHeight,
  cardTableHeight,
  isInitFilter = false,
  requiredRecallSyncId,
  changeRequiredRecallSyncIds,
  endReached,
  tableUpperActionBox,
  handleInitFilter,
  page = "favorite",
  handleClickButton,
  classes,
}) => {
  const toast = useToast();
  const dir = document.documentElement.dir; // 'ltr' 또는 'rtl'

  const navigate = useNavigate();
  const startDownload = useStartDownload();

  const {
    getContentFavorite,
    getContentDownload,
    getContentsDownload,
    checkAIDocPermission,
    changeDragItem,
  } = useDocumentStore();
  const { workgroupState, updateStarItemFavorite } = useWorkgroupStore();
  const tableScrollRef = useRef<any>(null);
  const documentListNew = useRef([] as ColumnDatas[]);
  const documentListNewCard = useRef([] as any[]);

  const [docShowType, changeDocShowType] = useState<"smallCard" | "list">(
    window.eco.listView === "list" ? "list" : "smallCard"
  );
  const [checkboxGroup, changeCheckboxGroup] = useState<string[]>([]);
  const [key, setKey] = useState(0);
  const [showDocAside, setShowDocAside] = useState<boolean>(false);
  const [asideInfo, changeAsideInfo] = useState<{
    syncId: string;
    workgroupId: string;
    contentName: string;
    revisionNo: number;
  }>({
    syncId: "",
    workgroupId: "",
    contentName: "",
    revisionNo: -1,
  });
  const [settingButtonInfo, setDocSettingInfo] = useState<{
    x: number;
    y: number;
    syncId: string;
    docInfo?: DocInfo;
    folderInfo?: FolderInfoDTO;
  }>({
    x: 0,
    y: 0,
    syncId: "",
    docInfo: undefined,
    folderInfo: undefined,
  });
  const [extraModal, changeExtraModal] = useState("CLOSE");
  useEffect(() => {
    let newDataContent = [] as ColumnDatas[];
    let newDataCardContent = [] as any[];
    docInfo?.folder?.currntFolderList?.forEach((item, index) => {
      newDataContent.push(getFolderTableData(item, index));
      newDataCardContent.push(getFolderTableCardData(item));
    });
    docInfo?.docs?.doc?.forEach((item, index) => {
      newDataContent.push(getTableData(item, index));
      newDataCardContent.push(getTableCardData(item, index));
    });
    documentListNew.current = newDataContent;
    documentListNewCard.current = newDataCardContent;
    setKey(key + 1);
  }, [docInfo?.docs?.doc, docInfo?.folder?.currntFolderList, checkboxGroup]);
  useEffect(() => {
    changeCheckboxGroup([]);
    setDocSettingInfo({
      x: 0,
      y: 0,
      syncId: "",
      docInfo: undefined,
      folderInfo: undefined,
    });
    changeAsideInfo({
      syncId: "",
      workgroupId: "",
      contentName: "",
      revisionNo: -1,
    });
  }, [window.location.href]);
  useEffect(() => {
    changeCheckboxGroup(
      checkboxGroup?.filter(
        (item) =>
          !docInfo?.docs?.doc ||
          docInfo?.docs?.doc?.filter((item1) => item1.syncId === item)?.length >
            0
      ) ?? []
    );
    changeCheckboxGroup([]);
    // removeDocAsideWithId();
  }, [docInfo?.docs?.doc]);
  const openDocAsideWithId = (
    workgroupId: string,
    id: string,
    revisionNo: number,
    contentName: string
  ) => {
    const before = document.getElementsByClassName("docCard");
    const after = document.getElementById(`docCard-${id}`);
    for (let i = 0; i < before.length; i++) {
      before[i].classList.remove("asided");
    }
    if (after) after.classList.add("asided");

    changeAsideInfo({
      syncId: id,
      workgroupId: workgroupId,
      revisionNo: revisionNo,
      contentName: contentName,
    });
    !page.includes("manageStorage") && setShowDocAside(true);
  };
  const checkCheckbox = (targetSyncId: string) => {
    changeCheckboxGroup((check) =>
      check.includes(targetSyncId)
        ? check.filter((item) => item !== targetSyncId).map((item) => item)
        : [...check, targetSyncId]
    );
  };
  const handleDocDragStart = (e: any) => {
    e.stopPropagation();
    const emptyImg = new Image();
    emptyImg.src =
      "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
    e.dataTransfer.setDragImage(emptyImg, 0, 0);
  };
  const handleDocsDownload = async (syncIds: string[]) => {
    const checkResp = await docApi.docsDownloadCheck(syncIds);
    if (!checkResp && !checkResp.data && checkResp.data.length > 0) {
      toast.toastMsg(nanoid(), t("file.alert.noPermissionDownload"), "error");
    }
    let resp = await getContentsDownload({
      syncIds: syncIds,
      startDownload: startDownload,
    });
    if (resp.payload) {
      if (resp.payload.error) {
        if (
          resp.payload.error.name &&
          resp.payload.error.name !== "INTERNAL_SERVER_ERROR"
        ) {
          toast.toastMsg(nanoid(), resp.payload.error.message, "error");
        } else {
          toast.toastMsg(nanoid(), t("file.alert.downloadFail"), "error");
        }
      } else {
        toast.toastMsg(
          nanoid(),
          syncIds.length === 1
            ? t("file.alert.downloadStart")
            : t("file.alert.docDownload", { name: "download.zip" }),
          "success"
        );
      }
    } else {
      toast.toastMsg(nanoid(), t("file.alert.downloadFail"), "error");
    }
  };
  const handleDragStart = (row?: DocInfo) => {
    if (!row) return;
    changeDragItem(
      checkboxGroup.includes(row.syncId) &&
        docInfo?.docs?.doc.filter((item) => checkboxGroup.includes(item.syncId))
        ? docInfo?.docs?.doc.filter((item) =>
            checkboxGroup.includes(item.syncId)
          )
        : [row]
    );
  };
  const getFolderTableCardData = (row: FolderInfoDTO) => {
    return {
      id: row.folderId,
      data: (
        <Box
          classes={classNames("docCard")}
          id={`folderCard-${row.folderId}`}
          onContextMenu={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDocSettingInfo({
              x: dir === "ltr" ? e.pageX - 240 : e.pageX,
              y: e.pageY - 61,
              syncId: row.folderId,
              folderInfo: row,
            });
          }}
          onClick={() =>
            navigate(
              utilsCommon.renderProperNavigatePath(
                row.workgroupId === row.folderId
                  ? `/workgroup/${row.workgroupId}/file`
                  : `/workgroup/${row.workgroupId}/file?folderId=${row.folderId}`
              )
            )
          }
        >
          <Box classes="docCard-upper">
            <Button
              btnStyle={"icon"}
              size="sm"
              classes="docCard-setting"
              onClick={(e) => {
                e.stopPropagation();
                setDocSettingInfo({
                  x: dir === "ltr" ? e.pageX - 240 : e.pageX,
                  y: e.pageY - 61,
                  syncId: row.folderId,
                  folderInfo: row,
                });
              }}
              leadingIcon={<Icons variant="line" label="moreVertical" />}
            />
            <Box classes="docCard-thumbnail">
              <Icons variant="document" label="folder" size={48} />
            </Box>
          </Box>
          <Box classes="docCard-under">
            <Box direction={"column"} width="calc(100% - 40px)">
              <Box alignItems={"center"} classes="docCard-title">
                <Tooltip message={row.folderName}>
                  <Typography type="body2_rg" ellipsis>
                    {row.folderName}
                  </Typography>
                </Tooltip>
              </Box>
              <Box alignItems={"center"} classes={"docCard-under--date"}>
                <Typography
                  type="body4_rg"
                  exactColor={getColor("COLOR_TEXT_SECONDARY")}
                >
                  {utilsCommon.renderDateFormat(row.updateTime)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      ),
    };
  };
  const getTableCardData = (row: DocInfo, index: any) => {
    return {
      id: row?.syncId,
      data: (
        <DocCard
          row={row}
          setDocSettingInfo={setDocSettingInfo}
          asideId={asideInfo.syncId}
          needCheckbox={VISIBLE_TAB_BY_PAGE[page].includes("checkbox")}
          checkCheckbox={checkCheckbox}
          checkboxGroup={checkboxGroup}
          page={page}
          openDocAsideWithId={() =>
            openDocAsideWithId(
              row?.workgroup.workgroupId,
              row?.syncId,
              row?.revisionNo,
              row.contentName
            )
          }
        />
      ),
    };
  };
  /** 테이블 내부 아이템 */
  const getTableData = (row: DocInfo, index: any): ColumnDatas => {
    return {
      clickAction: (e) =>
        openDocAsideWithId(
          row?.workgroup.workgroupId,
          row?.syncId,
          row?.revisionNo,
          row.contentName
        ),
      checkBoxClick: VISIBLE_TAB_BY_PAGE[page].includes("checkbox")
        ? () => checkCheckbox(row?.syncId)
        : undefined,
      clickRAction: (e) => {
        e.stopPropagation();
        page !== "receivedFile" &&
          setDocSettingInfo({
            x: dir === "ltr" ? e.pageX - 240 : e.pageX,
            y: e.pageY - 61,
            syncId: row?.syncId,
            docInfo: row,
          });
      },
      onDragStart: (e) => {
        handleDocDragStart(e);
        handleDragStart(row);
      },
      data: renderTableInfo("body", row),
      id: row?.syncId,
      hover: (
        <>
          {!page.includes("trash") &&
            !page.includes("manageStorage") &&
            utilsCommon.checkMenuAvailble("preview", row) && (
              <Tooltip
                message={utilsCommon.renderViewTooltip(row?.contentName)}
              >
                <Button
                  btnStyle={"icon"}
                  size="sm"
                  leadingIcon={<Icons variant="line" label="preview" isOn />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDocPreview({
                      permission: "view",
                      workgroupId: row?.workgroup?.workgroupId,
                      syncId: row?.syncId,
                      toast,
                      t,
                      revisionNo: row?.revisionNo,
                    });
                  }}
                />
              </Tooltip>
            )}
          {!page.includes("trash") &&
            !page.includes("manageStorage") &&
            utilsCommon.checkMenuAvailble("editMode", row) && (
              <Tooltip
                message={utilsCommon.renderEditTooltip(row?.contentName)}
                classes="mg ml-4"
              >
                <Button
                  btnStyle={"icon"}
                  size="sm"
                  leadingIcon={<Icons variant={"line"} label={"edit"} isOn />}
                  onClick={(e) => {
                    e.stopPropagation();
                    gotoEditMode(
                      row?.workgroup?.workgroupId,
                      row?.syncId,
                      toast
                    );
                  }}
                />
              </Tooltip>
            )}
          {page === "receivedFile" && (
            <Tooltip message={t("file.copyLink")}>
              <Button
                btnStyle={"icon"}
                size="sm"
                classes="mg ml-4"
                leadingIcon={<Icons variant="line" label="link" />}
                onClick={(e) => {
                  e.stopPropagation();
                  copy(
                    `${window.location.origin}/client/download?syncId=${row.syncId}`
                  );
                  toast.toastMsg(
                    nanoid(),
                    t("file.link.copySuccess"),
                    "success"
                  );
                }}
              />
            </Tooltip>
          )}
          {!page.includes("trash") && !page.includes("manageStorage") && (
            <Tooltip message={t("common.download")}>
              <Button
                btnStyle={"icon"}
                size="sm"
                classes="mg ml-4"
                leadingIcon={<Icons variant="line" label="download" />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDocDownload(row.syncId, getContentDownload, toast, t);
                }}
              />
            </Tooltip>
          )}
          {page !== "receivedFile" && (
            <Button
              btnStyle={"icon"}
              size="sm"
              classes="mg ml-4"
              onClick={(e) => {
                e.stopPropagation();
                setDocSettingInfo({
                  x: dir === "ltr" ? e.pageX - 240 : e.pageX,
                  y: e.pageY - 61,
                  syncId: row?.syncId,
                  docInfo: row,
                });
              }}
              leadingIcon={<Icons variant="line" label="moreVertical" />}
            />
          )}
        </>
      ),
    };
  };
  /** 폴더 내부 아이템 */
  const getFolderTableData = (row: FolderInfoDTO, index: any): ColumnDatas => {
    return {
      clickRAction: (e) => {
        e.stopPropagation();
        setDocSettingInfo({
          x: dir === "ltr" ? e.pageX - 240 : e.pageX,
          y: e.pageY - 61,
          syncId: row?.folderId,
          folderInfo: row,
        });
      },
      clickAction: () =>
        navigate(
          utilsCommon.renderProperNavigatePath(
            row.workgroupId === row.folderId
              ? `/workgroup/${row.workgroupId}/file`
              : `/workgroup/${row.workgroupId}/file?folderId=${row.folderId}`
          )
        ),
      data: [
        {
          columnText: <Box />,
        },
        {
          columnText: (
            <Box>
              <Icons variant="document" label="folder" />
              <Tooltip message={row?.folderName} maxWidth={"calc(100% - 80px)"}>
                <Typography type="body2_rg" classes="mg ml-12 mr-12" ellipsis>
                  {row?.folderName}
                </Typography>
              </Tooltip>
            </Box>
          ),
        },
        {
          columnText: <Box />,
        },
        {
          columnText: <Box />,
        },
        {
          columnText: <Box>{utilsCommon.renderDateFormat(row.updateTime)}</Box>,
        },
      ],
      id: row?.folderId,
      hover: (
        <Button
          btnStyle={"icon"}
          size="sm"
          classes="mg ml-4"
          onClick={(e) => {
            e.stopPropagation();
            setDocSettingInfo({
              x: dir === "ltr" ? e.pageX - 240 : e.pageX,
              y: e.pageY - 61,
              syncId: row?.folderId,
              folderInfo: row,
            });
          }}
          leadingIcon={<Icons variant="line" label="moreVertical" />}
        />
      ),
    };
  };

  /** UI: 헤더 */
  const renderDocHeader = () => {
    const hasFolderPath =
      docInfo?.folder?.parentFolderList &&
      docInfo?.folder?.parentFolderList?.length > 0;
    return (
      <Box
        minHeight={page === "workgroupFile" ? (hasFolderPath ? 94 : 56) : 44}
        // alignItems="center"
      >
        <Box direction="column">
          {hasFolderPath && renderDocPath()}
          {checkboxGroup.length === 0 ? (
            <Box
              alignItems="center"
              height={page === "workgroupFile" ? undefined : 44}
              style={{
                marginTop:
                  page === "workgroupFile"
                    ? hasFolderPath
                      ? "10px"
                      : "auto"
                    : 0,
                marginBottom:
                  page === "workgroupFile" && !hasFolderPath ? 12 : 0,
                // alignSelf: "center",
              }}
            >
              <Typography type="subtitle2">
                <Trans
                  i18nKey="file.withCount"
                  values={{ count: docInfo?.total ?? 0 }}
                  components={{
                    1: (
                      <Typography
                        type="subtitle2"
                        exactColor={getColor("COLOR_TEXT_BRAND")}
                      />
                    ),
                  }}
                />
              </Typography>
              {docInfo?.folder?.currntFolderList &&
                docInfo?.folder?.currntFolderList.length > 0 && (
                  <Box alignItems="center">
                    <Typography type="subtitle2" classes="mg ml-2 mr-2">
                      ·
                    </Typography>
                    <Typography type="subtitle2">
                      <Trans
                        i18nKey="file.folderWithCount"
                        values={{
                          count: docInfo?.folder?.currntFolderList?.length ?? 0,
                        }}
                        components={{
                          1: (
                            <Typography
                              type="subtitle2"
                              exactColor={getColor("COLOR_TEXT_BRAND")}
                            />
                          ),
                        }}
                      />
                    </Typography>
                  </Box>
                )}
            </Box>
          ) : (
            <Box
              alignItems="center"
              height={page === "workgroupFile" ? undefined : 44}
              style={{
                marginTop:
                  page === "workgroupFile"
                    ? hasFolderPath
                      ? "10px"
                      : "auto"
                    : 0,
                marginBottom:
                  page === "workgroupFile" && !hasFolderPath ? 12 : 0,
              }}
            >
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_BRAND")}
              >
                {checkboxGroup.length}
              </Typography>
              <Typography
                type="subtitle2"
                classes={classNames({
                  "mg ml-4": i18n.language.includes("en"),
                })}
              >
                {t("file.selectedWithCount")}
              </Typography>
            </Box>
          )}
        </Box>
        {page === "trash" ? (
          <Box classes="mg ml-auto" style={{ alignSelf: "flex-start" }}>
            {checkboxGroup.length > 0 && (
              <>
                <Button
                  btnStyle={"link"}
                  leadingIcon={<Icons variant="line" label="redoLeft" />}
                  label={t("trash.action.restore")}
                  onClick={() => changeExtraModal("restore")}
                />
                <Button
                  btnStyle={"link"}
                  type="error"
                  leadingIcon={<Icons variant="line" label="delete" />}
                  classes="mg ml-8"
                  label={t("trash.action.permDelete")}
                  onClick={() => changeExtraModal("delete")}
                />
              </>
            )}
          </Box>
        ) : page.includes("manageStorage") ? (
          <Box classes="mg ml-auto" style={{ alignSelf: "flex-start" }}>
            {checkboxGroup.length > 0 && (
              <>
                <Button
                  btnStyle={"link"}
                  type="error"
                  leadingIcon={<Icons variant="line" label="delete" />}
                  classes="mg ml-8"
                  label={t("common.delete")}
                  onClick={() => changeExtraModal("delete")}
                />
              </>
            )}
          </Box>
        ) : (
          <Box
            classes="mg ml-auto"
            alignItems="center"
            style={{
              position: "relative",
              marginTop:
                page === "workgroupFile" && hasFolderPath ? 38 : undefined,
            }}
          >
            {tableUpperActionBox
              ? tableUpperActionBox(
                  docInfo?.docs?.doc?.filter((item) =>
                    checkboxGroup.includes(item.syncId)
                  )
                )
              : checkboxGroup.length > 0 && (
                  <>
                    <Button
                      btnStyle={"link"}
                      leadingIcon={<Icons variant="line" label="download" />}
                      label={t("common.download")}
                      onClick={() => handleDocsDownload(checkboxGroup)}
                    />
                    {utilsCommon.getAIChatAvailibility() && (
                      <Tooltip message={t("file.aiChat.alert.selectTooltip")}>
                        <Button
                          btnStyle={"link"}
                          leadingIcon={<Icons variant="line" label="ai" />}
                          classes="mg ml-8"
                          label="K-Assistant"
                          onClick={() =>
                            uploadToAIAssistant({
                              docs:
                                docInfo?.docs?.doc.filter((item) =>
                                  checkboxGroup.includes(item.syncId)
                                ) ?? [],
                              checkAIDocPermission,
                              changeDragItem,
                              toast,
                            })
                          }
                        />
                      </Tooltip>
                    )}
                  </>
                )}
            <Box width={8} />
            {(["list", "smallCard"] as ("smallCard" | "list")[]).map((item) => (
              <Button
                btnStyle={"icon"}
                onClick={() => changeDocShowType(item)}
                // style={{
                //   alignSelf: "flex-start",
                // }}
                leadingIcon={
                  <Icons
                    variant="line"
                    label={item === "list" ? "list" : "grid"}
                    stroke={
                      docShowType === item
                        ? getColor("COLOR_ICON_BRAND")
                        : undefined
                    }
                  />
                }
              />
            ))}
          </Box>
        )}
      </Box>
    );
  };

  const getProperBody = (menu: string, row?: DocInfo) => {
    switch (menu) {
      case "star":
        return {
          columnText: (
            <Box
              classes={"mg ml-auto cursor pointer"}
              width={"fit-content"}
              onClick={(e: any) => {
                e.stopPropagation();
                if (!row) return;
                getContentFavorite({
                  syncIds: [row?.syncId],
                  flag: row?.favoritDate <= 0,
                  page: page,
                });
                updateStarItemFavorite({
                  syncIds: [row?.syncId],
                  flag: row?.favoritDate <= 0,
                });
              }}
            >
              <Icons
                variant="fill"
                label="star"
                isColored={!!row?.favoritDate && row?.favoritDate > 0}
                size={20}
              />
            </Box>
          ),
          isHover: row?.favoritDate === 0,
          isHoverOn: row?.favoritDate && row?.favoritDate > 0,
        };
      case "fileSize":
        return {
          columnText: (
            <Typography ellipsis type="body2_rg">
              {utilsDocs.fileSizeFormat(row?.fileSize)}
            </Typography>
          ),
        };
      case "fileName":
        return {
          columnText: (
            <Box alignItems="center">
              <span style={{ minWidth: "24px", height: "24px" }}>
                {utilsDocs.renderDocIcon(row?.contentName, 24)}
              </span>
              <Tooltip
                message={row?.contentName}
                maxWidth={"calc(100% - 80px)"}
              >
                <Typography
                  type="body2_rg"
                  classes={classNames("mg ml-12 mr-12", {
                    "hover-text-underline":
                      !page.includes("trash") &&
                      !page.includes("manageStorage") &&
                      utilsCommon.checkMenuAvailble("preview", row),
                  })}
                  ellipsis
                  onClick={(e: any) => {
                    e.stopPropagation();
                    row &&
                      !page.includes("trash") &&
                      !page.includes("manageStorage") &&
                      utilsCommon.checkMenuAvailble("preview", row) &&
                      handleDocPreview({
                        permission: "view",
                        workgroupId: row?.workgroup?.workgroupId,
                        syncId: row?.syncId,
                        toast,
                        t,
                        revisionNo: row?.revisionNo,
                      });
                  }}
                >
                  {row?.contentName}
                </Typography>
              </Tooltip>
              {page === "trash" ? (
                <DeleteTag deleteDate={row?.deleteDate} classes={"mg mr-4"} />
              ) : (
                <RevisionTag revisionNo={row?.revisionNo} classes={"mg mr-4"} />
              )}
            </Box>
          ),
        };
      case "memo":
        return {
          isNoPadding: true,
          columnText: (
            <Box width={"fit-content"} direction="row">
              {!!row?.signCount && row?.signCount > 0 && (
                <Tooltip
                  message={t("file.commentWithCount", {
                    count: row?.signCount,
                  })}
                >
                  <Box>
                    <Icons variant="line" label="memo" />
                    <Typography classes="mg ml-2" type="body2_rg">
                      {row?.signCount}
                    </Typography>
                  </Box>
                </Tooltip>
              )}
            </Box>
          ),
        };
      case "info":
        return {
          columnText: (
            <Box classes={"mg ml-auto"} width={"fit-content"} height={20}>
              {row?.readRequestDate && row?.readRequestDate > 0 ? (
                <Tooltip message={t("header.setAlarm.request")}>
                  <Icons
                    variant="fill"
                    label="alertCircle"
                    stroke={getColor("COLOR_ICON_ERROR")}
                  />
                </Tooltip>
              ) : row?.checkoutUser.userId !== "" ? (
                <Tooltip
                  message={
                    <Box direction="column">
                      <Typography
                        exactColor="white"
                        type="body4_rg"
                        fontWeight={700}
                      >
                        {row?.checkoutUser.userName ?? row?.checkoutUser.userId}
                      </Typography>
                      <Typography exactColor="white" type="body4_rg">
                        {t("file.revisionInDesktop")}
                      </Typography>
                    </Box>
                  }
                >
                  <Icons variant="fill" label="clientRevision" />
                </Tooltip>
              ) : row?.concurrentUserId !== null &&
                row?.concurrentUserId !== "" ? (
                <Tooltip
                  message={
                    row?.checkoutUser.userName + " " + t("file.revisionInWeb")
                  }
                >
                  <Icons variant="fill" label="webRevision" />
                </Tooltip>
              ) : (
                <></>
              )}
            </Box>
          ),
        };
      case "lastUpdate":
        return {
          columnText: (
            <Typography ellipsis type="body2_rg">
              {utilsCommon.renderDateFormat(
                page.includes("trash") ? row?.deleteDate : row?.revisionDate
              )}
            </Typography>
          ),
        };
      case "workgroup":
        return {
          columnText: (
            <Tooltip
              message={
                row?.workgroup.workgroupId === "NONEWORKGROUP"
                  ? "My Box"
                  : row?.workgroup.workgroupName
              }
            >
              <Typography ellipsis type="body2_rg">
                {row?.workgroup.workgroupId === "NONEWORKGROUP"
                  ? "My Box"
                  : row?.workgroup.workgroupName}
              </Typography>
            </Tooltip>
          ),
        };
      case "masterUser":
      case "sender":
        return {
          columnText: (
            <Typography ellipsis type="body2_rg">
              {row?.masterUser?.userName && row?.masterUser?.userName !== ""
                ? row?.masterUser?.userName
                : row?.masterUser?.userId}
            </Typography>
          ),
        };
      case "receiver":
        return {
          columnText: (
            <Typography ellipsis type="body2_rg">
              {row?.checkinUser?.userName && row?.checkinUser?.userName !== ""
                ? row?.checkinUser?.userName
                : row?.checkinUser?.userId}
            </Typography>
          ),
        };
    }
  };
  const getProperMenu = (menu: string) => {
    switch (menu) {
      case "star":
        return {
          headerText: "",
          width: "48px",
        };
      case "fileSize":
        return {
          headerText: t("admin.manage.fileSize"),
          width: "120px",
        };
      case "fileName":
        return {
          headerText: t("file.fileName"),
          width:
            page === "trash"
              ? "calc((100% - 240px) * 0.72) "
              : VISIBLE_TAB_BY_PAGE[page].includes("checkbox")
              ? "calc(100% - 627px)"
              : "calc(100% - 580px)",
          order: !filter?.order
            ? "downOff"
            : ["name", "file"].includes(filter?.order)
            ? "upOn"
            : ["namedesc", "filedesc"].includes(filter?.order)
            ? "downOn"
            : "downOff",
          orderAction: () => {
            if (documentListNew.current.length > 0 && changeFilterByKey) {
              changeFilterByKey("order", page === "favorite" ? "name" : "file");
              changeCheckboxGroup([]);
            }
          },
        };
      case "info":
        return {
          headerText: "",
          width: "48px",
          order: "",
          orderAction: () => {},
        };
      case "memo":
        return {
          headerText: "",
          width: "47px",
          order: "",
          orderAction: () => {},
          isNoPadding: true,
        };
      case "workgroup":
        return {
          headerText: t("common.location"),
          width: page === "trash" ? "calc((100% - 240px) * 0.28) " : "240px",
          order: "",
          orderAction: () => {},
        };
      case "lastUpdate":
        return {
          headerText: page === "trash" ? t("trash.date") : t("file.lastUpdate"),
          width: page === "trash" ? "200px" : "240px",
          order:
            filter?.order === "date"
              ? "upOn"
              : filter?.order === "datedesc"
              ? "downOn"
              : "downOff",
          orderAction: () => {
            if (documentListNew.current.length > 0 && changeFilterByKey) {
              changeFilterByKey("order", "date");
              changeCheckboxGroup([]);
            }
          },
        };

      case "receiver":
        return {
          headerText: t("file.reviser"),
          width: "200px",
          order: "",
          orderAction: () => {},
        };
      case "masterUser":
      case "sender":
        return {
          headerText:
            menu === "masterUser" ? t("file.master") : t("sendingFile.sender"),
          width: "200px",
          order: "",
          orderAction: () => {},
        };
    }
  };
  const renderTableInfo = (type: "header" | "body", row?: DocInfo) => {
    const returnList = [] as any[];
    const allowedType = VISIBLE_TAB_BY_PAGE[page];
    allowedType.forEach(
      (menu) =>
        menu !== "checkbox" &&
        returnList.push(
          type === "header" ? getProperMenu(menu) : getProperBody(menu, row)
        )
    );
    return returnList;
  };
  const renderDocPath = () => {
    return (
      <Box alignItems="center" classes={"mg mt-12"} height={40}>
        {docInfo?.folder?.parentFolderList &&
          docInfo?.folder?.parentFolderList.length >= 5 && (
            <>
              <Dropdown
                dropdownMaxHeight={394}
                buttonWidth={224}
                btnStyle="icon"
                placeholder=" "
                leadingIcon={<Icons label="moreVertical" variant="line" />}
                dropdownMaxWidth={224}
              >
                {docInfo?.folder?.parentFolderList
                  .filter(
                    (item1, index) =>
                      docInfo.folder?.parentFolderList &&
                      index < docInfo.folder?.parentFolderList.length - 3
                  )
                  .map((item) => (
                    <DropdownItem
                      onClick={() =>
                        navigate(
                          utilsCommon.renderProperNavigatePath(
                            item.workgroupId === item.folderId
                              ? `/workgroup/${item.workgroupId}/file`
                              : `/workgroup/${item.workgroupId}/file?folderId=${item.folderId}`
                          )
                        )
                      }
                      label={
                        item.workgroupId === item.folderId
                          ? workgroupState.workgroupDetail.workgroup
                              .workgroupName
                          : item.folderName
                      }
                    />
                  ))}
              </Dropdown>
              <Icons
                variant="line"
                label="chevron"
                direction="right"
                stroke={getColor("COLOR_ICON_INFO")}
              />
            </>
          )}
        {docInfo?.folder?.parentFolderList
          .filter(
            (item1, index) =>
              docInfo.folder?.parentFolderList &&
              (docInfo.folder?.parentFolderList.length < 5 ||
                index > docInfo.folder?.parentFolderList.length - 4)
          )
          .map((item) => (
            <>
              <Tooltip
                message={
                  item.workgroupId === item.folderId
                    ? workgroupState.workgroupDetail.workgroup.workgroupName
                    : item.folderName
                }
              >
                <Typography
                  ellipsis
                  type="body2_rg"
                  maxWidth={88}
                  classes="cursor pointer"
                  onClick={() =>
                    navigate(
                      utilsCommon.renderProperNavigatePath(
                        item.workgroupId === item.folderId
                          ? `/workgroup/${item.workgroupId}/file`
                          : `/workgroup/${item.workgroupId}/file?folderId=${item.folderId}`
                      )
                    )
                  }
                >
                  {item.workgroupId === item.folderId
                    ? workgroupState.workgroupDetail.workgroup.workgroupName
                    : item.folderName}
                </Typography>
              </Tooltip>
              <Icons
                variant="line"
                label="chevron"
                direction="right"
                stroke={getColor("COLOR_ICON_INFO")}
              />
            </>
          ))}
        <Tooltip
          message={
            docInfo?.folder?.folderInfo?.workgroupId ===
            docInfo?.folder?.folderInfo?.folderId
              ? workgroupState.workgroupDetail.workgroup.workgroupName
              : docInfo?.folder?.folderInfo.folderName
          }
        >
          <Typography
            ellipsis
            type="subtitle2"
            maxWidth={88}
            classes="cursor pointer"
          >
            {docInfo?.folder?.folderInfo?.workgroupId ===
            docInfo?.folder?.folderInfo?.folderId
              ? workgroupState.workgroupDetail.workgroup.workgroupName
              : docInfo?.folder?.folderInfo.folderName}
          </Typography>
        </Tooltip>
      </Box>
    );
  };
  const handleDeleteAfter = (syncIds: string[]) => {
    changeAsideInfo({
      syncId: "",
      workgroupId: "",
      contentName: "",
      revisionNo: -1,
    });
    setDocSettingInfo({
      x: 0,
      y: 0,
      syncId: "",
      docInfo: undefined,
      folderInfo: undefined,
    });
    changeCheckboxGroup(checkboxGroup.filter((id) => !syncIds.includes(id)));
  };
  return (
    <Box classes="documentBottom-body" height={height}>
      <Box direction="column" width="100%">
        {renderDocHeader()}
        {["restore", "delete"].includes(extraModal) && (
          <ConfirmDeleteOrRestoreModal
            open
            onClose={() => changeExtraModal("CLOSE")}
            onClickAfter={() => {
              changeCheckboxGroup([]);
              if (checkboxGroup.includes(asideInfo.syncId))
                changeAsideInfo({
                  syncId: "",
                  workgroupId: "",
                  contentName: "",
                  revisionNo: -1,
                });
              page.includes("manageStorage") &&
                changeFilterByKey &&
                changeFilterByKey("refresh", 0);
            }}
            type={
              extraModal === "restore"
                ? "restore"
                : page.includes("manageStorage")
                ? "adminDelete"
                : "delete"
            }
            syncIds={checkboxGroup}
          />
        )}
        {docShowType === "list" ? (
          <Box width="100%" direction="column">
            <Table
              width={"100%"}
              clickIds={
                VISIBLE_TAB_BY_PAGE[page].includes("checkbox")
                  ? checkboxGroup
                  : undefined
              }
              checkBoxClick={
                VISIBLE_TAB_BY_PAGE[page].includes("checkbox")
                  ? () => {
                      changeCheckboxGroup(() =>
                        docInfo?.docs?.doc &&
                        checkboxGroup.length < docInfo?.docs?.doc?.length
                          ? docInfo?.docs?.doc?.map((item) => item.syncId)
                          : []
                      );
                    }
                  : undefined
              }
              header={renderTableInfo("header")}
              targetId={settingButtonInfo.syncId}
              asideId={asideInfo.syncId}
              asideColor={
                VISIBLE_TAB_BY_PAGE[page].includes("checkbox")
                  ? "default"
                  : "theme"
              }
              columnHeight={"md"}
              height={
                documentListNew.current.length === 0
                  ? undefined
                  : listTableHeight
                  ? listTableHeight + ""
                  : page === "manageStorage_myBox"
                  ? "calc(100vh - 295px)"
                  : page.includes("manageStorage")
                  ? "calc(100vh - 362px)"
                  : "calc(100vh - 360px)"
              }
              endReached={endReached}
              data={documentListNew.current}
              totalCount={docInfo?.docs?.doc?.length}
              sideMenu={
                page.includes("manageStorage")
                  ? undefined
                  : showDocAside
                  ? "off"
                  : "on"
              }
              border={"none"}
              tableScrollRef={tableScrollRef}
              sideMenuAction={
                page.includes("manageStorage")
                  ? undefined
                  : () => setShowDocAside(!showDocAside)
              }
            />
          </Box>
        ) : (
          <Box direction={"column"}>
            <Box classes="documentBottom-cardHeader">
              {VISIBLE_TAB_BY_PAGE[page].includes("checkbox") &&
                docInfo?.docs?.doc &&
                docInfo?.docs?.doc?.length > 0 && (
                  <Checkbox
                    indeterminate={
                      docInfo?.docs?.doc &&
                      checkboxGroup.length > 0 &&
                      checkboxGroup.length < docInfo?.docs?.doc?.length
                    }
                    check={checkboxGroup.length === docInfo?.docs?.doc?.length}
                    onClick={
                      VISIBLE_TAB_BY_PAGE[page].includes("checkbox")
                        ? () => {
                            changeCheckboxGroup(() =>
                              docInfo?.docs?.doc &&
                              checkboxGroup.length < docInfo?.docs?.doc?.length
                                ? docInfo?.docs?.doc?.map((item) => item.syncId)
                                : []
                            );
                          }
                        : undefined
                    }
                  />
                )}
              <Dropdown
                // dropdownMaxWidth={224}
                btnStyle="link"
                placeholder=" "
                classes="mg ml-4"
                value={
                  SORT_TYPE.filter(
                    (item) => item.key === filter?.order.replace("file", "name")
                  )[0].label
                }
                buttonClick={key}
              >
                {SORT_TYPE.map((item) => (
                  <DropdownItem
                    type="check"
                    checkColor={
                      filter?.order?.replace("file", "name") === item.key
                    }
                    checked={
                      filter?.order?.replace("file", "name") === item.key
                    }
                    label={item.label}
                    onClick={() => {
                      setKey(key + 1);
                      changeFilterByKey &&
                        changeFilterByKey("order", `${item.key}_direct`);
                      changeCheckboxGroup([]);
                    }}
                  />
                ))}
              </Dropdown>
              <Box
                onClick={() =>
                  !page.includes("manageStorage") &&
                  setShowDocAside(!showDocAside)
                }
                classes="mg ml-auto cursor pointer"
              >
                <Icons
                  variant="line"
                  label="chevron"
                  direction={showDocAside ? "right" : "left"}
                  size={16}
                />
              </Box>
            </Box>
            <Box
              direction="column"
              classes={classNames("documentBottom-list", {
                isFavorite: page === "favorite",
              })}
            >
              {documentListNew.current.length > 0 && <Box height={16} />}
              <Cards
                width={"100%"}
                height={
                  documentListNew.current.length === 0
                    ? undefined
                    : cardTableHeight
                    ? cardTableHeight + ""
                    : "calc(100vh - 361px)"
                }
                size={
                  docShowType === "smallCard"
                    ? "sm"
                    : docShowType === "mediumCard"
                    ? "md"
                    : docShowType === "largeCard"
                    ? "lg"
                    : "sm"
                }
                data={documentListNewCard.current}
                endReached={() =>
                  endReached ? endReached() : console.log("!")
                }
                classes="documentBottom-cards"
              />
            </Box>
          </Box>
        )}
        {documentListNew.current.length === 0 &&
          (isInitFilter ? (
            <EmptyInitFilterPage
              pageType={page}
              handleClickButton={handleClickButton}
            />
          ) : (
            <EmptyFilterPage handleInitFilter={handleInitFilter} />
          ))}
      </Box>
      {showDocAside && <DocAside asideInfo={asideInfo} page={page} />}
      {settingButtonInfo.syncId && (
        <DocSettingButton
          page={page}
          filter={filter}
          changeAsideInfo={changeAsideInfo}
          settingButtonInfo={settingButtonInfo}
          requiredRecallSyncId={requiredRecallSyncId}
          asideInfo={asideInfo}
          changeRequiredRecallSyncIds={changeRequiredRecallSyncIds}
          setDocSettingInfo={setDocSettingInfo}
          handleDeleteAfter={handleDeleteAfter}
          changeFilterByKey={changeFilterByKey}
        />
      )}
    </Box>
  );
};
export default DocumentBottom;
